import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("nfc_cart")) || [];
    } catch {
      return [];
    }
  });
  const [cartOpen, setCartOpen] = useState(false);
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [clubUnlocked, setClubUnlocked] = useState(
    () => sessionStorage.getItem("nfc_club_unlocked") === "1"
  );

  const unlockClub = () => {
    sessionStorage.setItem("nfc_club_unlocked", "1");
    setClubUnlocked(true);
  };

  useEffect(() => {
    localStorage.setItem("nfc_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, size, color = "") => {
    setItems((prev) => {
      const existing = prev.find(
        (i) => i.id === product.id && i.size === size && i.color === color
      );
      if (existing) {
        return prev.map((i) =>
          i.id === product.id && i.size === size && i.color === color
            ? { ...i, qty: i.qty + 1 }
            : i
        );
      }
      return [
        ...prev,
        {
          id: product.id,
          name: product.name,
          price: product.price,
          image_url: product.image_url,
          size,
          color,
          qty: 1,
        },
      ];
    });
  };

  const removeItem = (id, size, color) =>
    setItems((prev) =>
      prev.filter((i) => !(i.id === id && i.size === size && i.color === color))
    );

  const setQty = (id, size, color, qty) => {
    if (qty < 1) return removeItem(id, size, color);
    setItems((prev) =>
      prev.map((i) =>
        i.id === id && i.size === size && i.color === color ? { ...i, qty } : i
      )
    );
  };

  const clearCart = () => setItems([]);

  const value = useMemo(
    () => ({
      items,
      addItem,
      removeItem,
      setQty,
      clearCart,
      cartOpen,
      setCartOpen,
      checkoutOpen,
      setCheckoutOpen,
      clubUnlocked,
      unlockClub,
      count: items.reduce((s, i) => s + i.qty, 0),
      total: items.reduce((s, i) => s + i.qty * i.price, 0),
    }),
    [items, cartOpen, checkoutOpen, clubUnlocked]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
